import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_APPLICATIONNOTEFULLHISTORY_FULFILLED = "FETCH_APPLICATIONNOTEFULLHISTORY_FULFILLED";
export const FETCH_APPLICATIONNOTEFULLHISTORY_REJECTED = "FETCH_APPLICATIONNOTEFULLHISTORY_REJECTED";
export const FETCH_APPLICATIONNOTEFULLHISTORY_PENDING = "FETCH_APPLICATIONNOTEFULLHISTORY_PENDING";
export const RESET_APPLICATIONNOTEFULLHISTORY = "RESET_APPLICATIONNOTEFULLHISTORY"

export function applicationNoteFullHistory(applicationId) {
    const token = localStorage.getItem("accessToken");

    return (dispatch) => {
        dispatch({
            type: "FETCH_APPLICATIONNOTEFULLHISTORY",
            payload: axios({
                method: "get",
                url: `${API_BASE}/api/v3/second-opinion/application-note-full-history?applicationId=${applicationId}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "multipart/form-data",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetApplicationNoteFullHistory() {
    return (dispatch) => {
        dispatch({
            type: "RESET_APPLICATIONNOTEFULLHISTORY",
        });
    };
}




